export interface CoachManageDeepLink {
  clientUid: string;
  subPage?: string;
}

const PREFIX = 'coachManage:';

// parse a coach push notification `data.page` value into a clientUid and optional sub-page.
// wire format emitted by the server (see buildPushPayload in coach-notify-payload.ts):
//   coachManage:{clientUid}                                -> { clientUid, subPage: undefined }
//   coachManage:{clientUid}:{segment}:{id}                 -> { clientUid, subPage: "{segment}:id~{id}" }
//   coachManage:{clientUid}:{segment}                      -> { clientUid, subPage: "{segment}" }  (unused today)
// returns null for any value that is not a coachManage payload, or has an empty uid.
// the subPage format mirrors what parseCoachDeepLinkPage reads (coach-manage-deep-link.ts).
export function parseCoachManageDeepLink(page: unknown): CoachManageDeepLink | null {
  if (typeof page !== 'string' || !page.startsWith(PREFIX)) return null;

  const afterPrefix = page.substring(PREFIX.length);
  const colonAfterUid = afterPrefix.indexOf(':');
  const clientUid = colonAfterUid >= 0 ? afterPrefix.substring(0, colonAfterUid) : afterPrefix;
  if (!clientUid) return null;

  // if no segment portion, uid-only deep link (e.g. clientMessage)
  if (colonAfterUid < 0) return { clientUid };

  const afterUid = afterPrefix.substring(colonAfterUid + 1);
  const colonAfterSegment = afterUid.indexOf(':');
  // if segment + id, rewrite as "segment:id~id" — the form parseCoachDeepLinkPage parses
  if (colonAfterSegment >= 0) {
    const segment = afterUid.substring(0, colonAfterSegment);
    const id = afterUid.substring(colonAfterSegment + 1);
    return { clientUid, subPage: `${segment}:id~${id}` };
  }
  // segment only, no id — pass bare segment through
  return { clientUid, subPage: afterUid };
}
